import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-5KBBMZ9LR6";

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== "undefined" && GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      testMode: process.env.NODE_ENV === "development", // Disable in development
    });
    console.log("Google Analytics initialized");
  }
};

// Track page views
export const trackPageView = (path) => {
  if (typeof window !== "undefined") {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

// Track custom events
export const trackEvent = (category, action, label, value, additionalParams = {}) => {
  if (typeof window !== "undefined") {
    ReactGA.event({
      category,
      action,
      label,
      value,
      ...additionalParams,
    });
  }
};

// Track button clicks
export const trackButtonClick = (buttonName) => {
  trackEvent("Button", "Click", buttonName);
};

// Track form submissions
export const trackFormSubmit = (formName) => {
  trackEvent("Form", "Submit", formName);
};

// Track navigation
export const trackNavigation = (destination) => {
  trackEvent("Navigation", "Navigate", destination);
};

